'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherCopy, FeatherExternalLink, FeatherRefreshCw } from '@subframe/core';
import { Badge, Button } from '@/shared/components/ui';
import type { Fatura } from '../types';
import { formatarDataHora } from '../utils/faturaFormatters';
import { formatarStatusAsaas, metodoPagamentoIcon, metodoPagamentoLabel, statusAsaasEncerrado } from '../utils/faturaStatusConfig';
interface FaturaAsaasCardProps {
  fatura: Fatura;
  onCopiarLink: () => void;
  onTentarReemissao: () => void;
  podeReemitir: boolean;
  saving: boolean;
}
export function FaturaAsaasCard(t0) {
  const $ = _c(32);
  const {
    fatura,
    onCopiarLink,
    onTentarReemissao,
    podeReemitir,
    saving
  } = t0;
  const {
    asaas
  } = fatura;
  const MetodoIcon = asaas.metodoPagamento ? metodoPagamentoIcon[asaas.metodoPagamento] : FeatherRefreshCw;
  const temErro = fatura.status === "ERRO_EMISSAO";
  let t1;
  if ($[0] !== asaas.statusAsaas || $[1] !== fatura.status) {
    t1 = (fatura.status === "EMITIDA" || fatura.status === "VENCIDA") && !statusAsaasEncerrado(asaas.statusAsaas);
    $[0] = asaas.statusAsaas;
    $[1] = fatura.status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cobravel = t1;
  const t2 = `flex flex-col gap-4 rounded-[16px] border border-solid p-6 ${temErro ? "border-error-200 bg-error-50/40" : "bg-default-background border-neutral-200"}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="text-body-bold font-body-bold text-default-font">Cobrança no Asaas</h3>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== asaas.atualizadoEm) {
    t4 = asaas.atualizadoEm && <span className="text-caption font-caption text-subtext-color">Atualizado em {formatarDataHora(asaas.atualizadoEm)}</span>;
    $[4] = asaas.atualizadoEm;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex flex-col gap-1">{t3}{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== asaas.statusAsaas || $[9] !== temErro) {
    t6 = temErro ? <Badge variant="error" icon={<FeatherAlertTriangle />}>Erro de emissão</Badge> : asaas.statusAsaas ? <Badge variant="brand">{formatarStatusAsaas(asaas.statusAsaas)}</Badge> : null;
    $[8] = asaas.statusAsaas;
    $[9] = temErro;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex items-start justify-between gap-3">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== MetodoIcon || $[15] !== asaas.erroEmissao || $[16] !== asaas.linkPagamento || $[17] !== asaas.metodoPagamento || $[18] !== cobravel || $[19] !== onCopiarLink || $[20] !== onTentarReemissao || $[21] !== podeReemitir || $[22] !== saving || $[23] !== temErro) {
    t8 = temErro && asaas.erroEmissao ? <div className="border-error-200 bg-default-background flex flex-col gap-3 rounded-[12px] border p-4"><div className="flex items-start gap-3"><FeatherAlertTriangle className="text-error-600 mt-0.5 h-5 w-5 shrink-0" /><div className="flex flex-col gap-1"><p className="text-error-700 text-body-bold font-body-bold">Falha ao emitir no Asaas</p><p className="text-error-700 text-sm">{asaas.erroEmissao}</p></div></div>{podeReemitir && <Button variant="brand-primary" size="medium" icon={<FeatherRefreshCw />} loading={saving} onClick={onTentarReemissao}>Tentar emitir novamente</Button>}</div> : !cobravel ? <p className="text-sm text-neutral-500" data-testid="fatura-asaas-nao-cobravel">Esta cobrança não aceita mais pagamento. O link foi retirado para não ser reenviado ao cliente por engano.</p> : asaas.linkPagamento ? <><div className="flex flex-col gap-3 rounded-[12px] bg-neutral-50 p-4"><div className="flex items-center justify-between gap-3"><span className="text-caption font-caption text-subtext-color">Link de pagamento</span><Badge variant="neutral" icon={<MetodoIcon />}>{asaas.metodoPagamento ? metodoPagamentoLabel[asaas.metodoPagamento] : "N\xE3o informado"}</Badge></div><div className="flex items-center justify-between gap-3"><code className="text-default-font truncate font-mono text-sm">{asaas.linkPagamento}</code><div className="flex shrink-0 items-center gap-1.5"><Button variant="neutral-tertiary" size="small" icon={<FeatherCopy />} onClick={onCopiarLink}>Copiar</Button><Button variant="neutral-secondary" size="small" icon={<FeatherExternalLink />} onClick={() => window.open(asaas.linkPagamento, "_blank")}>Abrir</Button></div></div></div></> : <p className="text-sm text-neutral-500">Sem link de pagamento ativo no Asaas no momento.</p>;
    $[14] = MetodoIcon;
    $[15] = asaas.erroEmissao;
    $[16] = asaas.linkPagamento;
    $[17] = asaas.metodoPagamento;
    $[18] = cobravel;
    $[19] = onCopiarLink;
    $[20] = onTentarReemissao;
    $[21] = podeReemitir;
    $[22] = saving;
    $[23] = temErro;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== asaas.asaasId) {
    t9 = asaas.asaasId && <div className="text-caption font-caption text-subtext-color">ID da cobrança no Asaas: <span className="font-mono">{asaas.asaasId}</span></div>;
    $[25] = asaas.asaasId;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t2 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = <div className={t2}>{t7}{t8}{t9}</div>;
    $[27] = t2;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}